module.exports = __webpack_public_path__ + "images/index/img04.166bdfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/artfriends/img04.jpg
// module id = nXex
// module chunks = 21